module.exports = __webpack_public_path__ + "static/media/RP-B_S_Neutral.a984180b.png";